import * as Yup from 'yup';

export const ingCCTPSchema = Yup.object().shape({
	title: Yup.string().required('Veuillez renseigner un titre'),
	origin: Yup.string().required('Veuillez renseigner une origine'),
})
